import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';
import moment from 'moment';
import {connect} from 'react-redux';
import * as Actions from 'actions';

// NOTE: Please see conditional return in render function.
// The component will now render differently depending on which props it receives.
// - Ben

class PostList extends React.Component {
	constructor(props) {
		super(props);
		this.confirmDelete = this.confirmDelete.bind(this);
		this.deletePost = this.deletePost.bind(this);
		this.displayName = 'PostList';
	}
	componentWillMount() {
		if(!this.props.hasPermission('/Post/View/')) {
			this.context.router.goBack();
		}
	}
	componentDidMount() {
	    $('.modal-basic').magnificPopup({
			type: 'inline',
			preloader: false,
			modal: true
		});

	}
	confirmDelete(e) {

		e.preventDefault();
		// debugger;
		var popupId = e.target.parentElement.attributes.getNamedItem('data-popup-id').value;
		var postId = e.target.parentElement.attributes.getNamedItem('data-post-id').value;
		if(typeof this.props.handleDeletePost === 'function')
		{
			$.magnificPopup.open({
				items : {
					src : '#'+popupId
				},
				type : 'inline',
			});

			$('#'+popupId+' .modal-confirm').click(this.deletePost);
			this.setState({ delete_id : postId })
		}
	}
	deletePost() {
		var id = this.state.delete_id;
		if(id) {
			this.props.handleDeletePost(id);
			this.setState({ delete_id : null });
			$.magnificPopup.close();
		}

	}
	render() {
		var posts = this.props.posts;
		var confirmDelete = this.confirmDelete;
		var deletePost = this.deletePost;
		var _self = this;

		return (
			<tbody>
			{posts.map(function(post) {

				var title = post.title;
				var author = "";

				if(post.author != null && post.author.name) {
					author = post.author.name.first + " " + post.author.name.last;
				}
				else {
					author = "No author defined.";
				}

				return(
					<tr key={post._id} className="gradeX">
						<td><Link to={"/posts/edit/"+post._id}>{title}</Link></td>
						<td>
						{(()=>{
							if(typeof post.excerpt === 'string')
								return post.excerpt.slice(3, post.excerpt.length-4)
						})()}
						</td>
						<td>{author}</td>
						<td>{moment(post.edit_date).format('hh:mm a - MM/DD, YYYY')}</td>
						{(()=>
						{
							if (typeof _self.props.handleDeletePost !== 'undefined' && typeof _self.props.handleAddPost !== 'undefined') {
								return (
									<td className="actions">
										<Link to={"/posts/edit/"+post._id} title="Show Preview" className="on-default edit-row"><i className="fa fa-pencil"></i></Link>
										<a href="#" className="on-default remove-row" onClick={confirmDelete} data-popup-id={"popup_" + post._id} data-post-id={post._id}><i className="fa fa-trash-o"></i></a>

										<div id={"popup_" + post._id} className="modal-block mfp-hide">
											<section className="panel">
												<header className="panel-heading">
													<h2 className="panel-title">Are you sure?</h2>
												</header>
												<div className="panel-body">
													<div className="modal-wrapper">
														<div className="modal-text">
															<p>Are you sure that you want to delete this post?</p>
														</div>
													</div>
												</div>
												<footer className="panel-footer">
													<div className="row">
														<div className="col-md-12 text-right">
															<button className="btn btn-primary modal-confirm">Confirm</button>
														</div>
													</div>
												</footer>
											</section>
										</div>
									</td>
								);
							}
						})()}
					</tr>
				)
			})}
			</tbody>

		);
	}
};

PostList.contextTypes = {
    router : PropTypes.object
}

var mapStateToProps = function(state) {
    return { connection : state.connection };
}

export default connect(mapStateToProps, Actions)(PostList);



// WEBPACK FOOTER //
// ./src/browser/components/posts/postList.js